import React, { ReactNode, useCallback } from 'react';
import styled from 'styled-components';
import navStore from './navStore';

const StyledLink = styled.a<{
  current: number;
  index: number;
}>`
  color: ${({ index, current }) => {
    return index === current ? '#25b676' : '#b3b3b3';
  }};
  font-weight: 500;
  text-decoration: none;
  text-transform: uppercase;
  margin: 0 20px;
  width: 120px;
`;

export interface ILink {
  index: number;
  children: ReactNode;
  href: string;
}

const Link = ({ index, children, href }: ILink) => {
  const activeLink = navStore(state => state.activeLink);
  const setActiveLink = navStore(state => state.setActiveLink);
  const timeoutScroll = navStore(state => state.timeoutScroll);

  const handleClick = useCallback(() => {
    timeoutScroll();
    setActiveLink(index);
  }, [timeoutScroll, setActiveLink, index]);

  return (
    <StyledLink
      index={index}
      current={activeLink}
      href={href}
      onClick={handleClick}
    >
      {children}
    </StyledLink>
  );
};

export default Link;
